export enum PointOfSale {
  clover = 'clover',
  harborTouch = 'harborTouch',
  lightSpeed = 'lightSpeed',
  micros = 'micros',
  ncr = 'ncr',
  positouch = 'positouch',
  restaurantManager = 'restaurantManager',
  revel = 'revel',
  square = 'square',
  toast = 'toast',
  touchBistro = 'touchBistro',
  other = 'other',
  none = 'none',
}
